<template>
  <v-app id = "inspire">
   
    <v-main> 
      <v-navigation-drawer   
        app
        pdr50
        fixed
        clipped
        temporary
        :expand-on-hover  = "true"
        v-model           = "drawer"  
        width             = "200" 
        v-if              = "currentUser" 
        class             = "mt-8"
        style             = "z-index: 200;"
      >
        <!-- absolute -->
        <v-list dense >
          <template v-for="(item_product, index_product) of render_sidebar">
            <v-list-item
              v-if="item_product.enable && item_product.isView && !item_product.sub_modules && item_product.permission_user && userHasAnyMenuPermission(item_product)"
              :key="index_product"
              link
              @click="redirect_item(item_product.type, item_product.module)"
            >
              <v-list-item-action>
                <v-icon 
                  small 
                >
                  {{ item_product.icon }}
                </v-icon>
              </v-list-item-action>
              <v-list-item-content>            
                <v-list-item-title>
                  {{ $ml.get(item_product.module) }}
                </v-list-item-title>            
              </v-list-item-content>
            </v-list-item>

            <!-- products with sub modules -->
            <!-- :prepend-icon="item_product.icon"  -->
            <v-list-group 
              v-else-if="item_product.enable && item_product.isView && item_product.sub_modules && item_product.permission_user && hasVisibleSubModules(item_product)"
              :key="index_product"
            >
              <!-- currentUser && currentUser.user.roleId < 3 -->
              <template v-slot:activator>
                <v-list-item-action>
                  <v-icon 
                    small 
                  >
                    {{ item_product.icon }}
                  </v-icon>
                </v-list-item-action>
                <v-list-item-title>
                  {{ $ml.get(item_product.module) }}
                </v-list-item-title>
              </template>

              <!-- v-if="" -->
              <!-- currentUser && currentUser.user.roleId < 3 -->

              <template 
                v-for = "(item_product_sub, index_sub_product) of item_product.sub_modules"
              >                    
                <v-list-item 
                  :key="index_sub_product" 
                  link 
                  @click="redirect_item(item_product_sub.type, item_product_sub.sub_module)"
                  class="pl-6"
                  v-show="userHasAnyPermission(item_product_sub.sub_module || item_product_sub.module) && item_product_sub.enable"
                > 
                  <v-list-item-action>
                    <v-icon 
                      small 
                    >
                      {{ item_product_sub.icon }}
                    </v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ $ml.get(item_product_sub.title) }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
              <v-divider></v-divider>          
            </v-list-group>
          </template>
        </v-list>
      </v-navigation-drawer>

      <v-app-bar  
        app 
        clipped-left 
        dense
        height    = "37" 
        :fixed    = "true"

      > 
        <!-- min-width = "890px"  -->

      <v-app-bar-nav-icon 
        @click.stop = "drawer = !drawer" 
        v-if        = "currentUser"
      />

      <!-- <v-row no-gutters> justify="space-between" -->
       <!--  <v-col 
          md     = "2"  
          xl     = "2" 
          lg     = "2" 
          sm     = "2" 
          xs     = "2" 
          cols   = "2" 
          height = "20"
        > -->
          <v-btn 
            @click.prevent  = "$router.push('/dashboard')" 
            v-show          = "currentUser" 
            class           = "mt-0 pa-0 mr-1"
          >
          <!-- logo_alice_security / alice-icon-app4 - alice-icon-app3 -->
          <v-img 
            contain
            v-show  = "this.$vuetify.theme.dark" 
            :src    = "$logos.logo_night" 
            width   = "85"  
            height  = "23"
            id      = "logo_night"
          ></v-img>     
          <v-img 
            contain
            v-show  = "!this.$vuetify.theme.dark" 
            id      = "logo_night"
            :src    = "$logos.logo_light" 
            width   = "85" 
            height  = "23" 
          ></v-img>
          <!-- <v-toolbar-title> Alice </v-toolbar-title> -->
        </v-btn> 


      <!-- </v-col>
      <v-col 
        md      = "6" 
        xl      = "6" 
        lg      = "6" 
        sm      = "6" 
        xs      = "6" 
        cols    = "6" 
        height  = "20"
      > -->
        <v-spacer></v-spacer>
        <!-- :curren_route="$router.currentRoute.name" -->
        <toolbar 

          v-if                = "currentUser" 
          :breaks             = "breakpoints" 
          :is_user            = "currentUser" 
          class               = "mt-2 d-none d-sm-flex"     
          @connection_status  = "loading_steps = $event"               
        ></toolbar>
        <v-spacer></v-spacer>        

      <!-- </v-col>
      <v-col 
        md      = "4" 
        xl      = "4" 
        lg      = "4" 
        sm      = "4" 
        xs      = "4" 
        cols    = "4" 
        height  = "20"
      >

        <v-row 
          no-gutters 
          justify = "end"
        > -->
          <!-- ********************** Connections ************************** -->
          <v-tooltip 
            bottom 
            v-model = "connections_tooltip"
          >
            <template  v-slot:activator="{ on }">
              <v-btn
                small
                icon
                outlined
                class   = "mr-3 mt-1"
                :color  = "color_connections == 'grey' ? 'grey' : 'primary' "
                v-show  = "currentUser"
              >
              <!-- @click="module_render()" -->
                <v-icon 
                  x-small 
                  v-on   = "on" 
                  :color = "color_connections"
                  v-show = "currentUser"
                >
                  mdi-server-network
                </v-icon>
              </v-btn>
            </template>
            <span> {{ $ml.get('connections') }}:</span><br>
            <template 
              v-for = "item_status, index of render_status_connections"
             
            >                  
            <!-- v-if="item_status.enable" -->
              <span
                :key = "index"
              >  
                {{ item_status && item_status.name ? item_status.name : 'No named'  }} : 
                <span 
                  :class = "`${item_status && item_status.color ? item_status.color : 'secondary'}--text`"
                > 
                  {{ item_status && item_status.status ? item_status.status : 'Not connected' }}
                </span> <br>                  
              </span>
            </template>
          </v-tooltip>

        <v-menu offset-y >
          <template v-slot:activator="{ on }">
            <v-btn 
              icon 
              dense 
              x-small 
              class  = "pr-0 mt-2 " 
              v-on   = "on" 
              v-show = "user"
            >                   
              <v-icon  
                :color  = "status_color" 
                :size   = "9" 
                v-show  = "user"  
              >
                mdi-circle
              </v-icon>
            </v-btn>
          </template>
          <v-list dense>
            <v-list-item-group dense>
              <v-list-item  
                @click = "status_color = 'green'" 
                dense
              >
                <v-list-item-action class="pa-0 ma-0">
                  <v-icon 
                    small 
                    color = "green"
                  >
                    mdi-circle
                  </v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title> {{ $ml.get('online') }} </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item 
                @click = "status_color = 'secondary'" 
                dense
              >
                <v-list-item-action 
                  class = "pa-0 ma-0"
                >
                  <v-icon 
                    small 
                    color = "secondary"
                  >
                    mdi-circle
                  </v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title> {{ $ml.get('offline') }} </v-list-item-title>
                </v-list-item-content>                
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-menu>


        <v-btn 
          text 
          v-show  = "currentUser"  
          @click  = "$router.push('/profile')" 
          width   = "80" 
          class   = "text-uppercase mt-1 px-0 justify-start" 
          style   = " font-size : 70%; 
                      overflow  : hidden;"
        >
          <!-- 77% -->
          {{ user }}           
        </v-btn>

        <v-tooltip bottom>
          <template v-slot:activator="{ on }">  
            <v-btn 
              dark                
              small
              :color = "virtual_Key ? 'primary' : 'secondary'"
              v-on   = "on"
              @click = "virtual_Key               =! virtual_Key"
              v-show = "currentRoute == 'Login'"
              class  = "mt-1"
            >
            <v-icon >
              mdi-keyboard
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $ml.get('virtual_keyboard') }}</span>
        </v-tooltip>

      <!-- move sesion in component menu notices -->        
      <notices v-if="currentUser"></notices>
      <v-menu 
        offset-y 
        left 
        bottom  
        v-if  = "currentUser"
      >
        <template v-slot:activator = "{ on }">
          <v-btn 
            icon 
            small 
            v-on    = "on" 
            class   = "mt-2" 
            v-if    = "currentUser"
            v-show  = "breakpoints && breakpoints.width < 673"
          >
          <!-- 1034 -->
            <v-icon 
              small 
              v-show  = "breakpoints && breakpoints.width < 673"
            >
            <!-- 1034 -->
              mdi-dots-vertical
            </v-icon>
          </v-btn>
        </template>

        <v-list dense>          
          <v-menu 
            left 
            bottom  
            offset-x
          >
            <template v-slot:activator = "{ on: menu }">                 
              <v-list-item 
                v-on    = "{ ...menu}" 
                v-show  = "breakpoints && breakpoints.width < 653"
              > <!-- icon / 972-->
                <v-list-item-icon 
                  class = "ma-2"
                >
                  <v-icon 
                    small 
                    color = "info" 
                    class = "mr-1"
                  > 
                    mdi-wan
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-title>   
                  {{ $ml.get('language') }}
                </v-list-item-title>
              </v-list-item>                    
            </template>                   
            <v-list>
              <v-list-item v-for="lang in langs" :key="lang">
                <v-btn @click="$ml.change(lang)">
                  {{ lang }}
                </v-btn>
              </v-list-item>
            </v-list>
          </v-menu>

          <v-list-item 
            v-on    = "on" 
            @click  = "change_theme" 
            v-show  = "breakpoints && breakpoints.width < 653"
          > <!-- = !theme  icon / 913-->
            <v-icon 
              small 
              class = "mr-1"
            ></v-icon>

            <v-list-item-icon class = "ma-2">
              <v-icon 
                small 
                color = "info" 
                class = "mr-1"
              >
                mdi-brightness-6
              </v-icon>
            </v-list-item-icon>
            <v-list-item-title>               
              <span 
                v-show = "$vuetify.theme.dark" 
              >
                {{ $ml.get('light') }} 
              </span>
              <span 
                v-show = "!$vuetify.theme.dark" 
              >
                {{ $ml.get('night') }} 
              </span>
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
                <!-- 
                  v-show  = "breakpoints && breakpoints.width > 972"
                > -->
                
                  <v-menu left bottom  offset-y>
                    <template v-slot:activator="{ on: menu }">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on: tooltip }">
                          <v-btn 
                            small 
                            v-on   = "{ ...tooltip, ...menu}" 
                            class  = "mt-1 caption primary--text" 
                            height = "32" 
                            :icon  = "!breakpoints.is_breaks"
                          > <!-- icon -->
                            <v-icon 
                              small 
                              color = "info" 
                              class = "mr-1"
                            >
                              mdi-wan
                            </v-icon>
                            <span 
                              v-show = "breakpoints.is_breaks"
                            >
                              {{ $ml.get('language') }}            
                            </span>
                          </v-btn>
                        </template>
                        <span>{{ $ml.get('language') }}</span>
                      </v-tooltip>
                    </template>
                    <v-list>
                      <v-list-item v-for="lang in langs" :key="lang">
                        <v-btn @click="$ml.change(lang)">
                          {{ lang }}
                        </v-btn>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                <!-- </v-col>
                  v-show = "breakpoints && breakpoints.width > 913"
                > -->
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">

                      <v-btn 
                        small 
                        v-on    = "on" 
                        @click  = "change_theme" 
                        height  = "32" 
                        class   = "mt-1 caption" 
                        :icon   = "!breakpoints.is_breaks"
                      > <!-- = !theme  icon-->
                        <v-icon 
                          small 
                          class = "mr-1"
                        >
                          mdi-brightness-6
                        </v-icon>
                        <span 
                          v-if   = "$vuetify.theme.dark" 
                          v-show = "breakpoints.is_breaks"
                        >
                          {{ $ml.get('light') }} 
                        </span>
                        <span 
                          v-else 
                          v-show = "breakpoints.is_breaks"
                        >
                          {{ $ml.get('night') }} 
                        </span>
                      </v-btn>            
                    </template>
                    <span 
                      v-if = "$vuetify.theme.dark"
                    >
                      {{ $ml.get('light') }}
                    </span>
                    <span  
                      v-else
                    > 
                      {{ $ml.get('night') }} 
                    </span>
                  </v-tooltip>
               <!--  </v-col>

                <v-col 
                  md    = "1" 
                  xl    = "2" 
                  lg    = "2" 
                  sm    = "2" 
                  xs    = "2" 
                  cols  = "2"
                > -->
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn small v-on="on" 
                        class           = "mt-1 caption primary--text" 
                        height          = "32" 
                        @click.prevent  = "logIn" 
                        v-show          = "!currentUser" 
                        :icon           = "!breakpoints.is_breaks"
                      >
                      <v-toolbar-title>    
                        <v-icon 
                          small 
                          color = "primary"
                        >
                          mdi-login
                        </v-icon>      
                      </v-toolbar-title>
                      <span 
                        class  = "ml-1" 
                        v-show = "breakpoints.is_breaks" 
                      >
                        {{ $ml.get('login')}}
                      </span>  
                    </v-btn>  
                  </template>
                  <span>{{ $ml.get('login')}}</span>
                </v-tooltip> 

                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn 
                      small 
                      v-on            = "on"                
                      v-show          = "currentUser"  
                      class           = "mt-1 mr-8" 
                      height          = "32" 
                      :icon           = "!breakpoints.is_breaks" 
                      @click.prevent  = "logOut" 
                      :disabled       = "logoutProcessing"
                    >       
                    <v-icon 
                      small 
                      color = "error"
                      v-show = "!logoutProcessing"
                    >
                      mdi-logout
                    </v-icon>
                    <v-progress-circular
                      v-show = "logoutProcessing"
                      indeterminate
                      size = "16"
                      width = "2"
                      color = "error"
                    ></v-progress-circular>
                    <!-- v-show="$vuetify.breakpoint.name=='xl' || $vuetify.breakpoint.name=='lg'" -->
                    <span 
                      class  = "caption ml-1" 
                      v-show = "breakpoints.is_breaks"
                    >
                      {{ $ml.get('log_out')}}
                    </span>
                  </v-btn>
                </template>
                <span>{{ $ml.get('log_out')}}</span>
              </v-tooltip>
              <!-- </v-btn-toggle> -->

              <v-btn 
                fab
                right
                x-small             
                absolute
                height  = "25"
                width   = "25"
                v-show  = "show.btn_dashboard"
                class   = "mt-10 pa-0"
                @click  = "renderBtnSidebarDashboard =! renderBtnSidebarDashboard"
                :color  = "renderBtnSidebarDashboard ? 'error' : 'primary'" 
                style   = "z-index: 300;"
              >
              <!--  ml-3 -->
                <v-icon small v-show = "!renderBtnSidebarDashboard">mdi-plus</v-icon>
                <v-icon small v-show = "renderBtnSidebarDashboard">mdi-close</v-icon>
              </v-btn>              
        </v-app-bar>

  <v-container 
    fluid
    :style = "image_background.image"
    class  = "pa-2 pt-1 "
  >
    <router-view
      @status_steps = "loading_steps = $event"
      v-slot        = "{ Component, route }"
    >
      <transition name = "fade">
        <component 
          :is  = "Component" 
          :key = "route.path" 
        />
      </transition>
    </router-view>
    <notifications></notifications>
    <template v-if = "currentUser">

    <connections
      @sync_alrts     = "sync_cloud    = $event"
      @is_connect_ws  = "connection_ws = $event" 
      :devices        = "list_devices"
    />    
    <installation_progress />
      <!-- <installation_progress></installation_progress> -->
          </template>
          <v-snackbar 
            top 
            v-model = "active_tooltip"
            color   = "primary"
            style   = "margin-top:35px;"
          >
          <span>

            <v-progress-circular 
              centered
              indeterminate  
              v-show  = "sync_cloud || loading_steps"
              :size   = "13"
              :width  = "2"
              color   = "white"
            ></v-progress-circular>
            <span 
              v-show = "sync_cloud"
            >
              {{ $ml.get('sync_alarm_list') }}
            </span>
            <span 
              v-show = "loading_steps"
            >
              {{ loading_steps }}
            </span>
          </span>
        </v-snackbar>
        <v-bottom-sheet 
            dark
            inset 
            v-model  = "sheet" 
          >             
        <v-sheet 
          height = "300px" 
          class  = "pa-1"
        >
          <SimpleKeyboard 
            @onChange   = "onChange" 
            @onKeyPress = "onKeyPress" 
            :input      = "input" 
            :theme      = "theme_keyboard"
          />
        </v-sheet>
      </v-bottom-sheet>  
      </v-container>


      <v-footer 
        app
        style = "z-index: 200;"
      >
        <!-- <span class="mx-2">
          {{$ml.get('powered_by')}} : 
        </span>
        <v-hover v-slot="{hover}">
          <v-card  :elevation ="0" :color ="hover ? '#2C5C7C': 'transparent'" :class="{'on-hover':hover, 'cursor-pointer' :true }">
            <v-card-text class="pa-1 pb-0">
              
              <img 
                :src ="$API.ext+ (!$vuetify.theme.dark ? '/img/tags/ebenezer/black.svg' : '/img/tags/ebenezer/white.svg' )" 
                width="130"
                height="30" 

                @click="$Helper.redirectOpenWindow('https://ebenezertechs.com')" 
               
              ></img>
            </v-card-text>
          </v-card>
        </v-hover> -->
           
        <v-divider vertical class="mx-4"></v-divider>
        <span v-show = "currentRoute !== 'streaming'"> 
          &copy; 
          2022 - {{new Date().getFullYear()}}
        </span>
        <v-spacer></v-spacer>  
        <span class = "white--text body-2">
          {{ $Version_AG }}
        </span>

        <grid_paging
          v-show = "currentRoute == 'streaming'"
        ></grid_paging>
        <v-spacer></v-spacer>      
        <span
          class  = "grey--text caption"
          v-show = "currentRoute !== 'streaming'"
        >
          <span>
            {{ timezone_time.time }}
          </span>  
          <v-icon
            small
            class = "mx-1"
            color = "primary"
          >
            mdi-map-clock
          </v-icon>          
          {{ $timezone }}
        </span>
        
      </v-footer>

    </v-main>

  </v-app>
</template>
  <!-- <script src="https://cdnjs.cloudflare.com/ajax/libs/flv.js/1.5.0/flv.min.js"></script> -->
  <!-- Global site tag (gtag.js) - Google Analytics --> 
  <script 
    async 
    src = "https://www.googletagmanager.com/gtag/js?id=UA-127508299-1%22%3E" 
  >
  </script> 
    
     
   

<script>
  
  if (location.origin.includes("alicesecurity")) {
    console.log("Load data layer analytics ")

    /*window.dataLayer = window.dataLayer || []; 
    function gtag(){
      dataLayer.push(arguments);
    } 
    gtag('js', new Date()); gtag('config', 'UA-127508299-1'); */
    // gtag('event', 'login', {'method': 'Google'});
  }

  import { MLBuilder }          from 'vue-multilanguage'
  import notices                from '@/components/info/MenuNotifications.vue'
  import EventBus               from '@/event-bus';
  import installation_progress   from '@/components/info/installation_progress.vue'
  // import config_logs from '@/components/config_logs.vue'
  import products_defaults      from '@/components/general_parameters/default_parameters.js'
  import toolbar                from '@/components/toolbar.vue'
  import connections            from '@/components/connections/connections.vue'
  // import new_device from '@/components/stream/new_device.vue'
  import notifications          from '@/components/info/notifications.vue'
  import axios                  from  'axios'
  // import installation_progress  from '@/components/info/installation_progress.vue'
  import grid_paging            from '@/components/dashboard/grid_paging.vue'
  import analytics_default      from '@/components/analytics/analytics_default.json'
  import license_parameter      from '@/components/analytics/license_parameters.json'
  import modules                from '@/class/modules';  
  import SimpleKeyboard         from "@/components/simple_Keyboard.vue";
  import bar_option             from "@/views/bar_options.json"
  import sounds_defaults        from '@/components/general_parameters/sounds_default.js';
  import WindowControls         from '@/components/WindowControls.vue'

  // import analytics              from '@/class/analytics';
  export default {
    name: 'app',
    components:{ 
      notices,  
      toolbar, 
      installation_progress,
      notifications,
      connections,
      // installation_progress,
      grid_paging,
      SimpleKeyboard,
      WindowControls
      
      // new_device,
      //, config_logs
      //crud_device
    }, // componenents 
    props: {
      source: String,
    },
    data: vm => ({
      drawer: false,
      user: '',
      option: false,
      user: '',
      on: false,
      on1: false,
      collapse:false,
      theme: false,
      status_color:'green',
      state: false,  
      status_user: false,
      btn_dashboard: false,
      virtual_Key: false,
      show_debug: false,
      sync_cloud: false,
      loading_steps: '',
      active_tooltip: false,
      connection_ws: false,
      status_message: 
      [
      {
        name: "cloud",
        property: "ws_cloud",
        status: '',
        color_message: '',
        enable: false,
      },
      {
        name: "blacklist",
        property: "blacklist_socket",
        status: '',
        color_message: '',
        enable: false,
      },  
      {
        name: "safe_zone",
        property: 'sz',
        status: '',
        color_message: '',
        enable: false,
      },
      {
        name: "message",
        property: 'msg',
        status: '',
        color_message: '',
        enable: false,
      },
      ],
      list_modules:[],
      btn_module: {
        device: false,
      },
      list_devices: [],
      connections_tooltip: false,  
      color_connections: 'primary',
      list_licences: analytics_default,
      started: false,
      list_associate: [],
      show_dashboard: false, // btn dashboard
      image_background: {

        lg : `url(img/bg-grande.png)`,
        md :`url(img/bg-mediano.png)`,
        xs :`url(img/bg-pequeno.png)`,
        // '''img/bg-mediano.png'
        image: { 
          'backgroundImage': `url('img/bg-grande.png')`, 
          width:'100%',
          height:'100%',
          position: 'relative',
          'backgroundPosition': 'center',

        },        
      },

      config_module :   null,
      // config_analytics: null,
      list_logos    : ['login',
        'login_night',
        'favicon',
        'logo_light',
        'logo_night',
        'background'
      ],
      info_logos : {
        'login' : '',   // @/assets
        'login_night' : '', //@/assets
        'favicon' : '',
        'logo_light' : '/img/alice_guardian.png',
        'logo_night' : '/img/alice_guardian1.png',
        'background'  : 'img/bg-grande.png',
      },
      theme_keyboard    : 'hg-theme-default myTheme1', // myTheme1
      sheet             : false,
      input             : '',
      setting_keyboard  : {}, 
      bar_options       : bar_option,
      timezone_time     : {
        time      : '',
        interval  : null,
        countMin : 0,
      },
      show : {
        btn_dashboard : true,
      },
      _routePermissionChecked: null, // Para evitar verificaciones duplicadas de permisos de ruta
      logoutProcessing: false, // Added for logout processing state
    }), // data

    watch:{
      collapse:function(v){
        EventBus.$emit('get_collapse', v);
      },
      
      sync_cloud(v){
        if (v) {
          this.active_tooltip = true;
        }else{
          this.active_tooltip = false;
        }
      },
      loading_steps(v){
        if (v) {
          this.active_tooltip = true;
        }else{
          this.active_tooltip = false;
        }
      },
      // Resetear la verificación de permisos cuando cambie la ruta
      '$route'(to, from) {
        if (to.name !== from.name) {
          this._routePermissionChecked = null;
        }
      },
      /*list_modules: function(v){
        if (v) {
          console.log(v, "    MODULES *****************++", new Date());
        }
      },*/
    }, // watch

    created () {    
      
      if (localStorage.getItem('General_parameters')) {
        this.list_modules = JSON.parse(localStorage.getItem('General_parameters'));    
        // localStorage.removeItem('General_parameters');            
      }

      if (localStorage.getItem('Analytics')) {
        this.list_licences        = JSON.parse(localStorage.getItem('Analytics'));
      }
      if (localStorage.getItem('Device_Analytics')) {
        this.list_associate       = JSON.parse(localStorage.getItem('Device_Analytics'));
      }

      if (this.currentUser) {
        
        this.actions('start');
        // this.config_module.update_list(products_defaults, 'modules');

        
      }
      

      if (this.$router.currentRoute.name == 'Login' && this.$store.state.auth.user) {
        this.$router.push('/dashboard');
      }     

      // setting format      
      this.$Format.update_list('ml', this.$ml);
      this.$Record.update_list('ml', this.$ml);

      this.start_time_timezone();
    }, // created

    computed: {
      // userLog(){
      //   this.user =this.$store.state.auth.user.user;
      //   if(this.user){
      //     return this.user.username;
      //   }else{
      //     this.user="";
      //   }
      // },
      currentUser() {
        if (this.$store.state.auth.user){
          this.user = this.$store.state.auth.user.user.Username;            
        }
        return this.$store.state.auth.user;      

      },
      showAdminBoard() {
        if (this.currentUser && this.currentUser.roles) {
          return this.currentUser.roles.includes('ROLE_ADMIN');
        }

        return false;
      },
      showModeratorBoard() {
        if (this.currentUser && this.currentUser.roles) {
          return this.currentUser.roles.includes('ROLE_MODERATOR');
        }

        return false;
      },
      mlmyMessage () {
        return new MLBuilder('msg')//.with('f', this.friends).with('l', 406)
      },

      breakpoints() {
        // console.log(this.$vuetify.breakpoint.name, this.$vuetify.breakpoint.width, 'breackpoints')
        


        let breakpoints_width = this.$vuetify.breakpoint.width;
        this.image_background.image.backgroundImage = 'url(' + this.$logos.background + ')';
        // console.log('LOGOSSSS ================', this.$logos.background)
        switch (this.$vuetify.breakpoint.name) {
            //'xs'  //true // '220px'
            case 'xs': {
              //this.image_background.xs;
              return  { is_breaks:false, width: breakpoints_width}
            };
            //'sm'  //true // '400px'
            case 'sm': {
              // this.image_background.image.backgroundImage = 'url(' + this.$logos.background + ')';
              //this.image_background.xs;
              return  { is_breaks:false, width: breakpoints_width}
              
            };
            //'md'  //true // '500px'
            case 'md': {
              // this.image_background.image.backgroundImage = 'url(' + this.$logos.background + ')';
              //this.image_background.xs;
              return  { is_breaks:false, width: breakpoints_width}
              
            };
            //'lg'  //true // '600px'
            case 'lg': {
              // this.image_background.image.backgroundImage = 'url(' + this.$logos.background + ')';
              //this.image_background.lg;
              return  { is_breaks:true, width: breakpoints_width}
              
            };
            //'xl'  //true // '800px'
            case 'xl': {
              // this.image_background.image.backgroundImage = 'url(' + this.$logos.background + ')';
              //this.image_background.lg;
              return  { is_breaks:true, width: breakpoints_width}

            };
          }
        },
        render_sidebar: function(){
         /* if (!this.list_modules) {
            this.module_render();
          }*/
          return this.list_modules.modules;
        }, // render sidebar

        render_status_connections: function(){
          return this.status_message;
        }, // render status connections

        currentRoute(){
          
          /*['can_edit', 'can_add', 'can_view', 'can_delete'].forEach((act)=>{
            if (this.$route && this.$route.name) {
              console.log("permission : *** ", this.$route.name, act ,this.$store.getters["auth/permission"]( this.$route.name,  act))
            }
          })*/
          // console.log("+++++++++++", this.$store.getters["auth/list_default_resources"])
          this.$nextTick(()=>{
            
            if (this.$route && this.$route.name) { 
            // [1, 2].includes(this.$store.state.auth.user.user.roleId)   / this.$Helper.update_list("permissions", this.$store.getters["auth/permissions"]);              / this.$Helper.check_permission("dashboard", "can_edit")
              let route     = this.$route.name;
              let resources = this.$store.getters["auth/list_default_resources"];
              let modul     = "";             

              if (location && location.pathname && location.pathname.includes("app") && this.$EXT.includes("app")) {
                let pathname  = location.pathname.split("/");
                console.log("pathname ", pathname, pathname[1], route, this.$store.getters["auth/permission"](pathname[1],  "can_view", modul));
                // route         = pathname[1].toLowerCase(); 
              }
              if (route.includes("dashboard")) {
                route = "dashboard";
              }
                if (resources && resources.length > 0) {
                  let idx       = resources.findIndex(x => {
                    if (!x || !route) {
                      return false;
                    }

                    const routeName = route.toLowerCase();
                    const moduleName = x.module ? String(x.module).toLowerCase() : "";
                    const subModuleName = x.sub_module ? String(x.sub_module).toLowerCase() : "";

                    return routeName === moduleName || routeName === subModuleName;
                  });
                  if (idx >= 0) {
                    modul = resources[idx].modul || resources[idx].module; 
                  }
                }
              
              // Verificar si los permisos ya están cargados antes de hacer la verificación
              const permissions = this.$store.getters["auth/permissions"];
              if (!permissions || Object.keys(permissions).length === 0) {
                // Si los permisos no están cargados, esperar a que se carguen
                this.$store.dispatch('auth/list_permissions').then(() => {
                  // Una vez cargados los permisos, hacer la verificación
                  this.checkRoutePermission(route, modul);
                }).catch(() => {
                  // Si hay error al cargar permisos, permitir acceso temporalmente
                  console.warn("Error loading permissions, allowing temporary access");
                });
              } else {
                // Si los permisos ya están cargados, hacer la verificación inmediatamente
                this.checkRoutePermission(route, modul);
              }
              
              if (this.$route.name.includes('dashboard') && this.$store.getters["auth/permission"]( "dashboard",  "can_add")) {
                this.show.btn_dashboard = true;            
              }else{
                this.show.btn_dashboard = false;
              }
            }
          })
          
          return this.$route && this.$route.name ? this.$route.name : this.$route;

        }, // currentRoute

        renderBtnSidebarDashboard:{
          get(){
          return this.$store.getters["Dashboard/getSidebarGrid"];
          },
          set(value){
            this.$store.commit("Dashboard/setSidebarGrid", value);
          }
        },

        langs() {
          // Usar los mismos nombres que en ml.js
          return ['english', 'spanish', 'mongolian'];
        },

        userPermissions() {
          return this.$store.getters["auth/permissions"];
        },

    }, // computed
    methods: {
      logOut() {
        // Prevent multiple clicks
        if (this.logoutProcessing) {
          return;
        }
        
        this.logoutProcessing = true;
        
        try {
          EventBus.$emit("notifications_modal",{
            type  : "logout",  
            ID    : "app"        
          });
          
          // Add timeout as fallback in case EventBus fails
          setTimeout(() => {
            if (this.logoutProcessing) {
              console.warn('Logout confirmation timeout, proceeding with logout');
              this.logoutProcessing = false;
              this.log_out();
            }
          }, 5000); // 5 second timeout
          
        } catch (error) {
          console.error('Error emitting logout notification:', error);
          // Fallback: directly call log_out if EventBus fails
          this.logoutProcessing = false;
          this.log_out();
        }
      },
      log_out(){
        try {
          this.$store.dispatch('auth/logout');
          if (localStorage.getItem('General_parameters')) {
            localStorage.removeItem('General_parameters');
          }
          
          // Solo navegar si no estamos ya en la ruta de login
          if (this.$route.path !== '/') {
            this.$router.push({ path : '/'});
          }
          
          this.user = null;
          EventBus.$emit("notifications_modal",{
            type : "success",
            message : this.$ml.get("closed_session"),           
          });
        } catch (error) {
          console.error('Error in log_out:', error);
          // Ensure user is logged out even if there's an error
          if (this.$route.path !== '/') {
            this.$router.push({ path : '/'});
          }
          this.user = null;
        }
      }, // log_out
      directLogout() {
        // Direct logout without confirmation dialog
        this.logoutProcessing = true;
        try {
          this.log_out();
        } catch (error) {
          console.error('Error in direct logout:', error);
          // Ensure user is logged out even if there's an error
          if (this.$route.path !== '/') {
            this.$router.push({ path : '/'});
          }
          this.user = null;
        } finally {
          this.logoutProcessing = false;
        }
      },
      testLogout() {
        // Test method to verify logout functionality
        console.log('Testing logout functionality...');
        console.log('Current user:', this.currentUser);
        console.log('Logout processing:', this.logoutProcessing);
        console.log('EventBus available:', typeof EventBus !== 'undefined');
        
        // Test direct logout
        this.directLogout();
      },
      logIn(){
        // if (this.$router.currentRoute.name !== 'dashboard' && this.currentUser) {
        //   this.$router.push('dashboard');
        // }

        // if (!this.currentUser) {
        // Solo navegar si no estamos ya en la ruta de login
        if (this.$route.path !== '/') {
          this.$router.push({ path : '/'}); 
        }
        // }
        // this.module_render();
      },
      Dashboard(){
        this.$router.push({ path : 'dashboard'});
      }, // dashboard


      change_theme(){
        let v = !this.$vuetify.theme.dark;
        this.$vuetify.theme.dark = v;
        // Guardar configuración del tema en localStorage
        localStorage.setItem('theme_dark', JSON.stringify(v));
      }, //theme

      
     

      actions(act){
        if (act == 'start') {
          // console.log(" ***************** INIT LISTS")
          
          this.config_module    = new modules(
            this.modules, 
            products_defaults,
            this.list_licences, 
            analytics_default, 
            this.list_associate, 
            this.currentUser
            );
          this.config_module.add_request(this.$localhost, this.$port);
          // console.log("DEFAULT SIDEBAR ***********************+", products_defaults)
          this.list_modules =  products_defaults;//this.config_module.module_render();
          /*// init sidebar elements
          this.module_render(); 
          */  
          this.config_module.update_list(products_defaults.modules, 'modules');
            
          this.list_modules =  this.config_module.module_render();

          // this.get_list_parameters();    
            // init list devices
          // this.get_list_devices();
          // init constellations
          this.get_constellation();  
          // init alarms
          this.get_alarms()
          //get list sounds
          this.get_sounds();

          this.$store.dispatch("Workspaces/get_workspaces");
           // this.$emit('status_steps', this.$ml.get('loading_devices_list'));
          this.loading_steps=this.$ml.get('loading_devices_list');
          this.$store.dispatch("Devices/get_devices").then(res=>{
            // console.log("LOADED DEVICES ", res)
            this.loading_steps=this.$ml.get('loaded_devices_list')
            // this.$emit('status_steps', this.$ml.get('loaded_devices_list'));
          });
          this.$store.dispatch('auth/list_resources').then(resources=>{                              
            this.$store.dispatch('auth/list_permissions').then((perms)=>{              
              if (perms) {            
                let views = [];
                let viewsInactives = [];
                for(let it in perms){                
                  if (it && perms[it].can_view) {
                    views.push(it);
                  }else if(it && !perms[it].can_view){
                    viewsInactives.push(it);

                  }
                }
                if (views.length > 0 || viewsInactives.length > 0) {
                  this.list_modules =  this.config_module.renderEnableModule(views, viewsInactives);                 
                }
              }
            });
          });
          this.$store.dispatch("Devices/set_items", { item : this.$Format, key : "Format" });
          this.$store.dispatch('auth/list_users').then(res=>{
            
            if (res) {
              this.$Format.update_list("list_users", [ ...res ]);
            }
          });


          // console.log("STORE ", this.$store)
        }
      }, // actions

      start_time_timezone(){
        this.timezone_time.time = this.$momentz(this.$momentz.now()).format('l, LT');// YYYY/MM/DD HH:mm A                        
        this.timezone_time.interval = setInterval(()=>{
            this.timezone_time.time = this.$momentz(this.$momentz.now()).format('l, LT'); // YYYY/MM/DD HH:mm A
            if (this.timezone_time.time.includes("0:00")) {
              this.$Helper.reloadPage();
            }            
            this.timezone_time.countMin++;
            if (this.timezone_time.countMin==10) {
              this.timezone_time.countMin=0;
              console.clear();
              const percent=this.$Helper.percentMonitorMemory();
              if (percent > 80) {
                if (this.$route && this.$route.name.includes("dashboard")) {
                  this.$Helper.reloadPage();              
                }
              }else{
                if (!percent) {                  
                  const splitTime = this.timezone_time.time.split(":");
                  if (splitTime[1].includes("00")) {
                    if (this.$route && this.$route.name.includes("dashboard")) {
                      this.$Helper.reloadPage();              
                    } 
                  }
                }
              }
            }
            this.$EventBus.$emit("event_time", { time : this.timezone_time.time });
            this.$store.commit("Counter/renderTime", this.timezone_time.time);
        }, 58000)        
        

      }, // start time timezone

      async get_list_devices(item = false, is_new){
          // const { itemsPerPage, page } = this.options;
          let page  = 1,
          pages = 2,
          list  = []; 
          while (page <= pages) {

            axios.defaults.withCredentials = false;
            const api = this.$URL + '/api/v1/device/?page=' + page;
            const listed =  await  axios.get(api).then( res => {
              // console.log(res, 'res get_list');
              let items   = res.data.rows;
              if (page == 1) {
                if (res.data.pages > 1 ){
                  pages = res.data.pages;              
                }
                list = items;
              }else{
                list = list.concat(items)
              }

              return list;
            }).catch( er => {
              console.log(er, 'Error get_list');
            })
            page++;
          } // while
          
          // console.log("************* CHECK LEN ", list.length)     ;

          if (list && list.length > 0) {     
            let vm      = this;


            // save list devices
            this.save_modules(list, 'list_devices');
            let list_temp = [...list ];     
            // console.log("DEVICES **************", list_temp)  
            this.$Format.update_list('devices', list_temp);
            this.config_module.update_list(list, 'devices');
            // set vars local
            this.list_devices  = list;
            EventBus.$emit('update_devices_list', list);
            this.$Devices      = list;
            this.show_dashboard = true;
            
            // save asssociate if its new
            if (item) {
              this.config_module.save_associate('create', item);     
            }

            // check list associate
            if (list.length > 0 &&  this.list_associate && this.list_associate.length > 0) {
              let temp_associate  = this.list_associate,
                  list_del        = [],
                  list_keep       = [];
              list.forEach( function(ar_check, idx_check){
                list_keep.push(ar_check.deviceId);

                temp_associate.forEach( function(assoc, idx_assoc){
                    if (ar_check.deviceId !== assoc.deviceId && !list_keep.includes(assoc.deviceId)) {
                      list_del.push(assoc.deviceId);
                    }
                })
              })
              // console.warn("list del : ", list_del, "list_keep", list_keep, "\n this its just for inform" );
            }

            // active license and module
            this.$nextTick( () =>{

              if (this.list_licences &&  this.list_licences.length > 0 && is_new) {                
                // console.log("Start render from device  ************** ");
                 this.list_modules = this.config_module.module_render('motion', 'active');   
                  
              }
            })


          } // list device
         /* if (list && list.length == 0) {
            this.$nextTick( () =>{
              this.reset_modules();
            })
          }*/
          




      }, // get list


      get_constellation(){        
        const api = this.$URL + '/api/v1/constellation/';
        this.$axios.get(api).then( res => {
            // console.log(res, 'Res get constellation');          
            if (res.data && res.data.rows && res.data.rows.length > 0) {
              // this.$constellation = res.data;
              this.$Constellations = res.data.rows;
              this.$Helper.set_local("constellations", res.data.rows)
            }
          }).catch( er => {
            console.log(er, 'Error get constellation');          
          });
      }, // get constellation

      async get_alarms(){
        let page = 1, 
        pages = 2,
        list = [];
        while(page < pages){
          const api = this.$URL + '/api/v1/alarm/?page=' + page;
          const listed = await this.$axios.get(api).then( res => {
            let items = res.data.rows;

            if (page == 1) {
              list = items;
              if (res.data.pages > 1) {
                pages = res.data.pages;

              }
            }else{
              list = list.concat(items);
            }
            return true;
          }).catch( er => {
            console.log(er, "Error get alarms");
          })
          page++;
          } // while
          if (list && list.length > 0) {
            localStorage.setItem('alarms', JSON.stringify(list));
          }

      }, // get alarms

      get_sounds(){
        const api = this.$URL + "/api/v1/sounds";

        this.$axios.get(api).then( res =>{
          let items = sounds_defaults;
          if (res && res.data && res.data.rows && res.data.rows.length > 0) {
            let items_1 = res.data;
            items_1.rows.forEach((item_row)=>{
              
              item_row.url_path = this.$URL + item_row.url_path;
              
            }); // forEach
            items.concat(items_1);
          }
          this.$Helper.set_local('list_sounds', items);
        }).catch( er => {
          console.log("Error get sounds ", er);
        });
      }, // get sounds
      


      get_list_parameters(){
        const api = this.$URL + '/api/v1/parameters';

        this.$axios.get(api).then( res => {
          // console.log("Get list parameters : ", res)
          const info = res.data && res.data.parameters ? res.data.parameters : null;
          if (info) {
            
            if (info.analytics && info.analytics.length > 0) {
              this.list_licences = info.analytics;
              this.config_module.update_list(info.analytics, 'analytics');              
            }
            
            if (info.device_analytics && info.device_analytics.length > 0) {
              this.list_associate = info.device_analytics;
              this.config_module.update_list(info.device_analytics, 'associates');
              this.save_modules(info.device_analytics, 'Device_Analytics');              
            }

            if (info.modules && info.modules.length > 0) {
              // console.log("set list modules")
              
              this.config_module.update_list(info.modules, 'modules');
            }
            this.list_modules =  this.config_module.module_render();
            /*console.log("RENDER LIST MODULES RETURN : **************: ", this.config_module.module_render('motion', 'active'))*/
          }
        }).catch( er => {
          console.log("Error get list parameters : ", er)
        })
      }, // get parameters
      get_parameters(item){
        const api = this.$URL + '/api/v1/parameters/';

        this.$axios.get(api + item).then( res => {
          console.log("Get parameters : ", res)
        }).catch( er => {
          console.log("Error get parameters : ", er)
        })
      }, // get parameters
      save_parameters(items, parameter){
        const api = this.$URL + '/api/v1/parameters';
        let info_up = {
          parameter,
          parameters: items, 
        }
        this.$axios.post(api, info_up).then( res => {
          console.log("create parameters : ", res)
        }).catch( er => {
          console.log("Error create parameters : ", er)
        })
      }, // save parameters

      update_parameters(items , parameter){
        const api   = this.$URL + '/api/v1/parameters/';
        let info_up = {
          parameter,
          parameters: items
        }
        this.$axios.put(api + parameter, info_up).then( res => {
          console.log("update parameters : ", res)
        }).catch( er => {
          console.log("Error update parameters : ", er)
        })
      }, // update parameters

      validUser(){        
        if (this.currentUser && this.currentUser.user && this.currentUser.user.id) {
          const api   = this.$URL + '/api/v1/auth/valid-user';
          this.$axios.get(api, {params : {id : this.currentUser.user.id} }).then(res=>{          
             if (res && res.data && !res.data.isValid) {
              this.log_out();            
            }
          }).catch(error=>{
            console.log("Error valid user", error)          
          })
        }

      }, // valid user

      save_modules(items, opt){
        // let list=null;
       /*
        'General_parameters' / modules
        'Analytics' /
        'Device_Analytics' / Associate 
        */
        if (items && opt) {                
          localStorage.setItem(opt, JSON.stringify(items));
        }
        // console.log("SAVE MODULES ***************** ", opt, items)
      }, // save modules

      render_time_connection(item = 'white'){
        this.color_connections    = item;
        // this.connections_tooltip  = true;

        let color_time = setTimeout( ()=>{
          this.color_connections  = "primary";
          if (item == 'white') { // actions.color_msg_ws
            this.color_connections = 'grey'
          }
          // this.connections_tooltip = false;
          clearTimeout(color_time);
        }, 3000)
      }, // render time connection

      redirect_item(type, module_item){      
        if (type == 'url') {
          const targetPath = '/' + module_item;
          if (this.$route && this.$route.path === targetPath) {
            return;
          }

          this.$router.push({path : targetPath});
        }else{
          this.btn_module[module_item] = !this.btn_module[module_item];

        }
      }, // redirect item

      searcher(list, search, key){
        if (list && list.length) {
          let obj = null,
          idx = null;
          const finded = list.some( function(arr_find, idx_find){
            // console.log(arr_find, idx_find);
            if ( arr_find == search || (key && arr_find[key] == search) ) {
              obj = arr_find;
              idx = idx_find;
              return true;
            }
          })
          if (finded) {
            return { obj, idx }
          }
        }
        return null;
      }, // find item

      onResize() {
        this.window_size = {
          width   : window.innerWidth,
          height  : window.innerHeight,
          size    : this.$vuetify.breakpoint.name
        };
        // console.log(this.window_size) 
        EventBus.$emit('responsive', this.window_size)
      }, // onResize

      onChange(input) {
        console.log("onChange : ", input, input.length)
        this.input          = input;
        // this.text_keyboard  = input;

        EventBus.$emit('keyboard_type' + this.setting_keyboard.ID, {
          setting : this.setting_keyboard,
          input
        });
      },// onChange
      
      onKeyPress(button) {
        console.log("button", button);
        if (button == "{bksp}") {
          let input1 = '';
          if (this.input.length === 0) {
            this.input = '';
          }else{
            // this.input = this.input.splice( this.input.length , 1);

          }
          input1 = this.input;
          EventBus.$emit('keyboard_type' + this.setting_keyboard.ID, {
            setting : this.setting_keyboard,
            input   : input1
          });
        }
        if (true) {          
           // EventBus.$off('keyboard_type' + this.setting_keyboard.ID);
          EventBus.$emit('keyboard_type_button' + this.setting_keyboard.ID, {
            setting : this.setting_keyboard,
            button
          });
        }
      }, //onKeyPress

      userCanView(subModuleName){
        if (!this.currentUser) return false;
        // Si el backend da can_view: true
        const perm = this.$store.getters["auth/permission"](subModuleName, "can_view");
        return perm;
      },

      userHasAnyPermission(moduleName){
        if (!this.currentUser || !moduleName) return false;

        return ["can_view", "can_add", "can_edit", "can_delete"].some(action => {
          return this.$store.getters["auth/permission"](moduleName, action);
        });
      },

      userHasAnyMenuPermission(moduleItem){
        if (!moduleItem) return false;

        if (this.userHasAnyPermission(moduleItem.module)) {
          return true;
        }

        const associatedItems = [
          ...((moduleItem.assosiateds) || []),
          ...((moduleItem.associateds) || []),
        ];

        if (associatedItems.some(item => item && item.enable !== false && this.userHasAnyPermission(item.sub_module || item.module))) {
          return true;
        }

        const associatedRoutes = moduleItem.assosiated_routes || moduleItem.associated_routes || [];
        return associatedRoutes.some(route => this.userHasAnyPermission(route));
      },

      hasVisibleSubModules(moduleItem){
        if (!moduleItem || !moduleItem.sub_modules || moduleItem.sub_modules.length === 0) {
          return false;
        }

        if (this.userHasAnyMenuPermission(moduleItem)) {
          return true;
        }

        return moduleItem.sub_modules.some(sub => {
          if (!sub || sub.enable === false) {
            return false;
          }

          return this.userHasAnyPermission(sub.sub_module || sub.module);
        });
      },

      resolveRoutePermissionAction(route) {
        const routeName = String(route || "").toLowerCase();

        if (routeName.startsWith("new_") || routeName.startsWith("add_")) {
          return "can_add";
        }

        return "can_view";
      },

      resolveRoutePermissionFallback(route) {
        const routeName = String(route || "").toLowerCase();

        if (["new_device", "new_peripheral"].includes(routeName)) {
          return "device";
        }

        return "";
      },

      checkRoutePermission(route, modul) {
        // Evitar verificaciones duplicadas para la misma ruta
        if (this._routePermissionChecked === route) {
          return;
        }

        const permissionAction = this.resolveRoutePermissionAction(route);
        const fallbackModule = this.resolveRoutePermissionFallback(route);
        const routeFallback = modul || fallbackModule;
        
        if (!this.$store.getters["auth/permission"](route, permissionAction, routeFallback)) {
          if (!["not_access_view", "*"].includes(route) && this.currentUser) {
            if (!["login", "dashboard", "user"].includes(route)) {                   
              this.$router.push({ path : "/not_access_view"});                    
            }
          }
        }
        
        // Marcar que ya se verificó esta ruta
        this._routePermissionChecked = route;
      },

    }, //methods

    mounted(){

      let vm = this;
      this.validUser();

      this.$nextTick(() => {
        this.onResize();
        window.addEventListener('resize', this.onResize);    
            
      })

      this.$vuetify.theme.dark = false;

      // Cargar configuración del tema desde localStorage
      if (localStorage.getItem('theme_dark')) {
        const themeDark = JSON.parse(localStorage.getItem('theme_dark'));
        this.$vuetify.theme.dark = themeDark;
      }

        if (localStorage.getItem('virtual_Key_board')) {
          this.virtual_Key = localStorage.getItem('virtual_Key_board');
        }
        EventBus.$on('active_keyboard_key', (action)=>{
          console.log("ACtive keyboard : ", action)
          if (action) {
            this.input            = action && action.value ? action.value : '';
            this.setting_keyboard = action;
            this.sheet            = true;
          }
        });

        // Add keyboard shortcut for logout (Ctrl+Shift+L)
        this.handleKeydown = (event) => {
          if (event.ctrlKey && event.shiftKey && event.key === 'L') {
            event.preventDefault();
            if (this.currentUser && !this.logoutProcessing) {
              console.log('Logout triggered by keyboard shortcut');
              this.logOut();
            }
          }
        };
        document.addEventListener('keydown', this.handleKeydown);


        if (localStorage.getItem('General_parameters')) {
          let info_config=JSON.parse(localStorage.getItem('General_parameters'));
          this.show_debug=info_config.debug;
        }
        
        this._onSidebarRender = (actions) => {
          try{
            let user = this.$Helper.get_local('user');            
            this.$axios.defaults.withCredentials  =   false;
            if (user && user.jwt) {
              this.$axios.defaults.headers.common["Authorization"] = `Bearer ${user.jwt}`;
              if (user.first_access_pwd) {
                this.$router.push({ path : "/profile"});
                this.$EventBus.$emit("notifications_modal",{
                  type    : "warning",
                  message : this.$ml.get("define_new_password"), 
                })
              }
            }
          }catch(e){
            console.warn("Error convert json usr", e);
          }
          this.actions("start");
        }
        EventBus.$on('sidebar_render', this._onSidebarRender);
        

        if (this.currentUser) {
          this.config_module.save_associate('check');
        }


        EventBus.$on('render_modules', (action) => {
          console.log('************ render_modules', action);
          if (action.name == 'new_device') {
            this.get_list_devices(action.associate, 'new_device');

          }else if(action.name == 'update_device') {
            this.get_list_devices();
          }else if (action.name == 'delete_device'){
            // console.log("DELETE Associate Analytics", action.associate)
            this.config_module.save_associate('delete', action.associate);
            
            //delete of list devices
            let ID =  null;

            // check uuid
            if (action && action.associate && action.associate.deviceId) {
              ID = action.associate.deviceId;

              // delete of array
              const find = vm.list_devices.some( (dev, idx_dev )=> {
                if (dev.deviceId == ID) {
                  // console.log("delete device list ********** ", dev, idx_dev)
                  vm.list_devices.splice(idx_dev, 1);
                  return true;
                }
              })
              
              if (find) {

                this.save_modules(vm.list_devices, 'list_devices');       
                this.config_module.update_list(vm.list_devices, 'devices');
              }
            }

          }else if(action.name == 'render'){
            this.config_module.module_render();

          }else{ // update
            // Add new module and associate with device
            this.config_module.module_render(action.name, 'new_module', true, action.associate)
          }
        })

        EventBus.$on('redirect_view', (route)=>{
          if (route){
            this.redirect_item('url', route);
          }else{
            console.log("Not route : ", route);
          }
        });


        EventBus.$on('status_sz', (actions) =>{
          this.status_message.sz=actions.status_msg;
          this.color_message.sz=actions.color_msg;
        })
        EventBus.$on('status_blacklist', (actions) =>{

          this.status_message.blacklist_socket=actions.status_msg_bl;
          this.color_message.blacklist_socket=actions.color_msg_bl;
        });

        EventBus.$on('status_ws', (actions) =>{          
          // console.log(actions, "Status Ws")
            /*this.status_message.ws_cloud=actions.status_msg_ws;
            this.color_message.ws_cloud=actions.color_msg_ws;*/
        });



        EventBus.$on('status_msg', (actions) =>{          
          this.status_message.msg=actions.status_msg;
          this.color_message.msg=actions.color_msg;
        });

        EventBus.$on('status_connections', (status) =>{
          this.status_message = status;
          this.render_time_connection('primary');
        })
        EventBus.$on("notifications_modal" + "app" ,(msg)=>{
          try {
            if (msg) {
              this.logoutProcessing = true;
              this.log_out();
            }
          } catch (error) {
            console.error('Error in logout confirmation:', error);
            // Fallback: ensure logout happens even if there's an error
            this.logoutProcessing = false;
            this.log_out();
          }
        });

        EventBus.$on("create_format_permission_user", (msg) => {
          this.$Format.create_permissions_user(msg);
        });

          /*EventBus.$on('new_module', (actions) =>{
            // console.log(actions, 'new module');
            this.module_render(actions, 'new_module');
          })*/

        // console.log('get states',this.loading_steps, this.sync_cloud)
        EventBus.$on('status_steps_loading',(msg)=>{
          this.loading_steps=msg;
        });
        if (this.loading_steps) {
          const timer_step = setTimeout(() =>{
            this.loading_steps = false;
            clearTimeout(timer_step);
          }, 8000) 
        }
        if (this.sync_cloud) {
          const timer_sync = setTimeout(() =>{
            this.sync_cloud=false;
            clearTimeout(timer_sync);
          }, 8000) 
        }
        
      this.$nextTick(()=>{
        this.$Record.init();
      })


      
    }, //mounted

    beforeDestroy() { 
      window.removeEventListener('resize', this.onResize); 
      if (this.timezone_time.interval) clearInterval(this.timezone_time.interval);
      
      // Remove keyboard event listener
      document.removeEventListener('keydown', this.handleKeydown);
      
      // Limpiar todos los EventBus listeners
      EventBus.$off('sidebar_render', this._onSidebarRender);
      EventBus.$off('status_blacklist');
      EventBus.$off('status_ws');
      EventBus.$off('status_msg');
      EventBus.$off('status_connections');
      EventBus.$off('notifications_modalapp');
      EventBus.$off('create_format_permission_user');
      EventBus.$off('status_steps_loading');
      EventBus.$off('render_modules');
      EventBus.$off('redirect_view');
      EventBus.$off('status_sz');
      EventBus.$off('active_keyboard_key');
      
      // Limpiar timers adicionales
      if (this.timer_step) clearTimeout(this.timer_step);
      if (this.timer_sync) clearTimeout(this.timer_sync);
    }, // beforeDestroy

  };
</script>
